import { PalmettoTag } from '@palmetto/dsm-components';

export const orphanValueWarning = 'Matches no catalog product';
export const noProductLineLabel = 'No product line';

interface ProductLineValueTagsProps {
  values: string[];
  orphanValues?: Set<string>;
}

export const ProductLineValueTags = ({ values, orphanValues }: ProductLineValueTagsProps) => (
  <div className="flex flex-row flex-wrap items-center gap-4">
    {values.map((value) =>
      orphanValues?.has(value) ? (
        <span key={value} className="inline-flex items-center gap-4" title={orphanValueWarning}>
          <PalmettoTag label={value} color="warning" />
          <span className="body-100 text-text-warning">{orphanValueWarning}</span>
        </span>
      ) : (
        <PalmettoTag key={value} label={value} />
      ),
    )}
  </div>
);
